import { AxiosError, AxiosRequestConfig } from 'axios';

export function shouldRetry(args: {
  method: string;
  status?: number;
  isNetworkError: boolean;
}): boolean {
  const { method, status, isNetworkError, } = args;

  if (isNetworkError) return true;
  if (status === 408 || status === 425 || status === 429) return true;
  if (status && status >= 500 && status < 600) return true;
  return false;
}

export function isNetworkError(err: AxiosError): boolean {
  return !!(err.code === 'ECONNABORTED' || (err.response == null && err.request));
}


export function expoJitterDelay(attempt: number, base = 200, cap = 4000): number {
  const exp = Math.min(cap, base * Math.pow(2, attempt));
  const jitter = Math.floor(Math.random() * (exp * 0.2));
  return exp - Math.floor(exp * 0.1) + jitter;
}

export function parseRetryAfter(header?: string): number | null {
  if (!header) return null;
  const secs = Number(header);
  if (!Number.isNaN(secs)) return Math.max(0, Math.floor(secs * 1000));
  const date = Date.parse(header);
  if (!Number.isNaN(date)) return Math.max(0, date - Date.now());
  return null;
}

export function wait(ms: number) {
  return new Promise<void>((r) => setTimeout(r, ms));
}
